import { Injectable, inject } from '@angular/core';
import { InterVuBooking } from '@core/models/IntervuBooking';
import { IntervuBookingDto } from '@core/models/dto/IntervuBookingModelDto';
import { Router } from '@angular/router';
import { HttpClientService } from '@core/services/http-client.service';
import { JsonFormatterService } from '@booking/common/json-formatter.service';
import { tap } from 'rxjs';
import { MessageService } from '@core/services/message.service';
import { MessageType } from '@core/enums/MessageType.enum';

@Injectable({
  providedIn: 'root'
})
export class BookResearchIntervuService {
  private httpClientService = inject(HttpClientService);
  private router = inject(Router);
  private messageService = inject(MessageService);
  private jsonFormmater = inject(JsonFormatterService);

  private mapObjectBeforSending(intervuBooking: InterVuBooking) {
    let res: IntervuBookingDto = { ...intervuBooking.getRawValue() };

    res.respondentMarkets.forEach((market: any) => {
      const { conductedInEnglish, dualChannel, country, referenceNumber } = market;
      market.onlineRespondentMarketDetail = { conductedInEnglish, dualChannel, country };
      market.referenceNumber = referenceNumber;
      market.sessions.forEach((session: any) => {
        session.referenceNumber = market.referenceNumber;
        session.advancedPrivacy = market.advancedPrivacy;
        session.timeZone = session.timezones;
        session.date = session.startDate;
        session.hoursStart = session.hoursStart === 'TBC' ? null : +session.hoursStart;
        session.hoursEnd = session.hoursEnd === 'TBC' ? null : +session.hoursEnd;
        session.minutesStart = session.minutesStart === 'TBC' ? null : +session.minutesStart;
        session.minutesEnd = session.minutesEnd === 'TBC' ? null : +session.minutesEnd;
      });

      let submitTranslators = !conductedInEnglish && dualChannel;  
      market.moderators = this.filterArray(market.moderators).map(m => ({ ...m, roleId: 1 }));
      market.translators = submitTranslators ? this.filterArray(market.translators).map(t => ({ ...t, roleId: 2 })) : [];
      market.recruiters = this.filterArray(market.recruiters).map(r => ({ ...r, roleId: 3 }));
      market.researchAssistants = [
        ...market.moderators,
        ...market.translators,
        ...market.recruiters
      ];
      delete market.moderators;
      delete market.translators;
      delete market.recruiters;
      market.onlineRespondentMarketDetail.dualChannel &&= !market.onlineRespondentMarketDetail.conductedInEnglish;
      if(!market.humanTranscript.transcript)delete market.humanTranscript;
      else delete market.humanTranscript.transcript;
    })
    res.interviewTypeId = +res.interviewTypeId;
    res.usingCamerasId = +res.usingCamerasId;
    if(res.billingDetail.poNumberNotRequired)delete res.billingDetail.poNumber;
    if(res.billingDetail.jobNumberNotRequired)delete res.billingDetail.jobNumber;

    return this.jsonFormmater.cleanData(res);
  }

  filterArray(array: Array<any>) {
    return array.filter(x =>
      Object.entries(x).some(([key, value]) => key !== 'id' && !!value)
    );
  }

  public save$(bookOnlineResearchRequest: InterVuBooking) {
    const mappedObj: IntervuBookingDto = this.mapObjectBeforSending(bookOnlineResearchRequest);
    return this.httpClientService.post(mappedObj, 'BookResearch/online').pipe(
      tap(() => this.router.navigate(['/thank-you']))
    );
  }

  public edit(bookOnlineResearchRequest: InterVuBooking, researchId: number) {
    const mappedObj: IntervuBookingDto = this.mapObjectBeforSending(bookOnlineResearchRequest);
    return this.httpClientService.put(mappedObj, `BookingDashboard/OnlineResearch/Edit/${researchId}`)
    .pipe(tap(() => this.messageService.loadMessage('Booking edited.', MessageType.SAVED)))
    .subscribe(() => this.onSucess());
  }

  onSucess() {
    this.router.navigate(['/profile/dashboard']);
  }
}
